if (!customElements.get('numbered-image-cards-slider')) {
  customElements.define(
    'numbered-image-cards-slider',
    class NumberedImageCardsSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';
        if (!this.enableSliderMobile) return;

        this.selectors = {
          sliderWrapper: '.grid__items',
          paginationEl: '.swiper-pagination',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };

        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.sliderInstance = false;

        this.init();
        document.addEventListener('matchMobile', () => {
          this.init();
        });
        document.addEventListener('unmatchMobile', () => {
          this.init();
        });
      }

      init() {
        if (AfcTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 8,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section.querySelector(this.selectors.paginationEl),
            clickable: true,
          },
          loop: true,
          autoHeight: true,
          threshold: 2,
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.AfcTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = AfcTheme.a11y.getFocusableElements(this);
        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideToLoop(index);
          });
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);

        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }
    }
  );
}
